<div class="warning-wrapper">
    <div class="app-modal-content">
        <h3 class="text-center title">
            {{ data.title }}
        </h3>
        <p class="text-center">
            {{ data.message }}
        </p>
        <img src="/assets/shared/eviction.gif" alt="warning" class="eviction-image" />
    </div>
    <div class="app-modal-footer-center" *ngIf="data.type === 'eviction'">
        <app-button
            [text]="'Go back'"
            [styles]="'light'"
            (output)="onGoBackClick()"
        ></app-button>
        <app-button
            [text]="'Take over'"
            [styles]="'primary'"
            (output)="onEvictClick()"
        ></app-button>
    </div>
    <div class="app-modal-footer-center" *ngIf="data.type === 'takeover-notice'">
        <app-button
            [text]="'I understand'"
            [styles]="'primary'"
            (output)="onTakeoverNoticeClick()"
        ></app-button>
    </div>
    <div class="app-modal-footer-center" *ngIf="data.type === 'takeover-confirmed'">
        <app-button
            [text]="'I understand'"
            [styles]="'primary'"
            (output)="onTakeoverConfirmedClick()"
        ></app-button>
    </div>
</div>